<template>
    <Autocomplete ref="autocomplete"
                  class="newHasher"
                  @select="selectOption"
                  @cancel="$emit('cancel')"
                  placeholder="Hash Name"
                  :startFocused="true"
                  :initializeWhenDone="true"
                  :options="options"
                  v-model="search"
                  :loadingCount="loadingCount"

    >
        <template v-slot:item="{option}">
            {{option.hash_name }}
        </template>
        <template v-slot:item-new>
            New Hasher: "{{search}}"
        </template>
    </Autocomplete>
</template>

<script>
  import HasherDao from '../../daos/HasherDao';
  import sortBy from 'lodash-es/sortBy';
  export default {
    name: "NewHasherBubble",
    props: {alreadySelected : {type: Array}},
    computed: {
      alreadySelectedIds() {
        return this.alreadySelected.map(hasher => hasher.id)
      },
      options() {
        let options = this.remoteOptions.slice(0,4);
        if (this.search) {
          options.push({slotKey: "new"});
        }
        return options;
      }
    },
    data() {
      return {
        search: null,
        loadingCount: 0,
        remoteOptions: []
      };
    },
    methods: {
      selectOption(option, input) {
        if (option.slotKey === "new") {
          this.createNewFunction(input);
        } else {
          this.$emit("select", option);
        }
      },
      createNewFunction: function (input) {
        this.loadingCount++;
        HasherDao.save({hash_name: input, id: "new"}).then(savedEntity => {
          this.$emit('select', savedEntity);
          this.loadingCount--;
          this.$nextTick(() => {this.$refs.autocomplete.$refs.input.focus()});
        });
      }
    },
      watch: {
        search() {
          if (!this.search) {
            this.remoteOptions = [];
          } else {
            let searchInput = this.search;
            HasherDao.fetchAllWithFilter(this.search)
              .then(hashers => sortBy(hashers, hasher => hasher.trails_ran.length).reverse())
              .then(hashers => hashers.filter(hasher => !this.alreadySelectedIds.includes(hasher.id)))
              .then(hashers => {
                if (this.search === searchInput)
                  this.remoteOptions = hashers
              });
          }
        }
      }
  }
</script>

<style lang="scss">
    .newHasher >>> .autocompleteInput {
        outline: none;
    }

    .newHasher >>> input, .newHasher >>> span {
        width: auto !important;
        padding-top: 0;
        padding-bottom: 0;
        text-align: center;
        font-size: 1em;
        position: relative;
        top: 50%;
        margin-top: -1em;
        flex-grow: 1;

    }
    //Todo better scoping
    .newHasher > input {
        outline: 0;
        border: 0;
        padding-top: 0;
        padding-bottom: 0;
        background-color: rgba(0, 0, 0, 0); //So loading indicator shows up. Redo when loading indicators standardized.
    }


</style>
